module.exports = __webpack_public_path__ + "img/img-success.04f885f7.png";